"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowWechat = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var FollowWechat = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FollowWechat, _super);
    function FollowWechat() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '关注公众号接口';
        _this.code = '101036';
        _this.desc = '关注公众号接口';
        _this.requestParams = new point_1.FollowWechatRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FollowWechat;
}(service_1.BaseService));
exports.FollowWechat = FollowWechat;
//# sourceMappingURL=followWechat.js.map